import $ from 'jquery';
require('./vendor/megamenu/megamenu.js');
require('./vendor/megamenu/megamenu-options.js');

$('.md-megamenu').slimmenu({
    resizeWidth: '800',
    collapserTitle: 'Main Menu',
    animSpeed: 100,
    indentChildren: true,
    childrenIndenter: '&raquo;'
});

$(document).on('scroll', function (event) {
  var scrollPos = $(document).scrollTop();
  var subMenuPos = $('.md-megamenu-sub-menu:visible').position().top;
  var isScrolledPastTop = scrollPos > subMenuPos
  var defaultPadding = 20;
  if (isScrolledPastTop) {
    var scrollDiff = scrollPos - subMenuPos + 10;
    $('.md-megamenu-sub-menu-child').css('padding-top', scrollDiff + 'px');
  } else {
    $('.md-megamenu-sub-menu-child').css('padding-top', defaultPadding + 'px');
  }
});



// WEBPACK FOOTER //
// ./lib/assets/js/main-nav.js